<template>
  <!-- 新建/编辑 -->
    <el-drawer
        :title="control.title"
        :enums="enums"
        :with-header="false"
        :visible.sync="control.show"
        direction="rtl"
        size="70%">
        <!-- <el-divider>创建</el-divider> -->
        <el-form status-icon :model="form" :rules="rules" ref="form" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="title" label="标题" :label-width="formLabelWidth">
                <el-input :disabled="control.disabled" v-model="form.title" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item prop="feedbackType" label="类型" :label-width="formLabelWidth">
                  <el-select
                    :disabled="control.disabled"
                    v-model="form.feedbackType"
                    clearable
                    filterable
                    size="small"
                    placeholder="请选择">
                  <el-option
                    v-for="item in enums.FeedbackTypeEnum"
                    :key="item.name"
                    :label="item.desc"
                    :value="item.name"
                  />
                </el-select>
             </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item prop="feedbackState" label="状态" :label-width="formLabelWidth">
                  <el-select
                    :disabled="control.disabled"
                    v-model="form.feedbackState"
                    clearable
                    filterable
                    size="small"
                    placeholder="请选择">
                  <el-option
                    v-for="item in enums.FeedbackStateEnum"
                    :key="item.name"
                    :label="item.desc"
                    :value="item.name"
                  />
                </el-select>
             </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item prop="targetType" label="对象类型" :label-width="formLabelWidth">
                  <el-select
                    :disabled="control.disabled"
                    v-model="form.targetType"
                    clearable
                    filterable
                    size="small"
                    placeholder="请选择">
                  <el-option
                    v-for="item in enums.FeedbackTargetTypeEnum"
                    :key="item.name"
                    :label="item.desc"
                    :value="item.name"
                  />
                </el-select>
             </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item prop="contactus" label="联系方式" :label-width="formLabelWidth">
                <el-input :disabled="control.disabled" v-model="form.phone" autocomplete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item prop="content" label="内容" :label-width="formLabelWidth">
            <el-input type="textarea" :disabled="control.disabled" v-model="form.content" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item prop="remark" label="备注" :label-width="formLabelWidth">
            <el-input type="textarea" :disabled="control.disabled" v-model="form.remark" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item :label-width="formLabelWidth">
            <el-button v-if="!control.disabled" type="primary" @click="handleSubmit(control.action)" size="mini">提交</el-button>
          </el-form-item>
        </el-form>
    </el-drawer>
</template>

<script>
import  * as AliossApi from '@/api/alioss'
import * as EnumApi from '@/api/enums'
import * as FeedbackApi from '@/api/feedback'
const OSS = require('ali-oss');
export default {
  name: 'FeedbackForm',
  props: {
    enums: '',
    control: Object
  },
  data() {
    var checkNumber = (rule, value, callback) => {
        if (!value && value!=0) {
          return callback(new Error('排序值不能为空'));
        }
        callback();
      };
    return {
      formLabelWidth: '100px',
      form: {},
      flag: '',
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init(){
      let that = this;
      console.log("init action >> " + that.control.action)
      if(that.$permits.CREATE === that.control.action){
        return
      }
      FeedbackApi.view(that.control.form.id).then(res => {
        let result = res.data;
        that.form = result.data;
      })
    },
    handleSubmit(action) {
      let that = this;
      console.log("action >> " + action)
      that.$refs['form'].validate((valid) => {
        console.log("validate >> starting...")
        if(valid){
          switch(action){
            case that.$permits.UPDATE:
              FeedbackApi.update(that.form).then(res => {
                that.control.show = false;
                that.$parent.handlePage();
              })
              console.log("switch >>> " + that.$permits.UPDATE)
              break;
            case that.$permits.CREATE:
              that.form.content = ''
              that.form.contentEn = ''
              FeedbackApi.create(that.form).then(res => {
                that.control.show = false;
                that.$parent.handlePage();
              })
              console.log("switch >>> " + that.$permits.CREATE)
              break;
          }
        }
        console.log("validate >> stop, valid: " + valid)
      });
    },
    updatePicture(flag) {
      this.flag = flag;
      this.$el.querySelector('.'+flag).click()
    },
    async handleFile(e) {
      console.log('e',e)
      const $target = e.target || e.srcElement
      var file = $target.files[0]

      let fileType = file.type.toLowerCase()
      let ext
      if(fileType.indexOf('image') >= 0){
        ext = '.jpeg';
      }

      let storeAs = process.env.VUE_APP_CURRENTMODE + '/' + Number(new Date().getTime()/(3600*24*7*1000)).toFixed(0) + '/' + this.guid().replace(/-/g,'') + ext
      console.log(storeAs);

      // OSS.urlib是sdk内部封装的发送请求的逻辑，开发者完全可以使用任何发请求的库向`sts-server`发送请求
      let res = await AliossApi.ststoken()
      const result = res.data.data
      const client = new OSS({
        accessKeyId: result.accessKeyId,
        accessKeySecret: result.accessKeySecret,
        stsToken: result.stsToken,
        endpoint: result.endpoint,
        bucket: result.bucket
      })
      client.put(storeAs, file).then(result => {
        let picUrl = result.res.requestUrls[0];
        if(this.flag == 'logo'){
          this.form.logo = picUrl;
        }else if(this.flag == 'weixinQrcode'){
          this.form.weixinQrcode = picUrl;
        }else if(this.flag == 'weiboQrcode'){
          this.form.weiboQrcode = picUrl;
        }
      }).catch(function(err) {})
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
        c) {
        var r = (Math.random() * 16) | 0
        var v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-drawer.rtl {
    right: 0;
    overflow-y: auto !important;
}
</style>
